import { render } from "./LocationForm.vue?vue&type=template&id=474ce0a6"
import script from "./LocationForm.vue?vue&type=script&lang=js"
export * from "./LocationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__